import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"
import { DigitalEnum } from "./Digital.schema"
import { socialMediaTypesConf } from "./referential"

const adhTeamConf = { disabled: true }

const socialMediaConf = Object.keys(socialMediaTypesConf).reduce(
  (acc, code) => {
    acc[`${DigitalEnum.SOCIAL_MEDIA_URLS}.${code}`] = adhTeamConf
    return acc
  },
  {} as Record<string, { disabled: boolean }>,
)

const adhTeamRoleConf = {
  [`${DigitalEnum.WEBSITE}.${DigitalEnum.SITE_URL}`]: adhTeamConf,
  [`${DigitalEnum.WEBSITE}.${DigitalEnum.WEBSITE_SERVICE}`]: adhTeamConf,
  ...socialMediaConf,
}

export const formRoleConf: RoleStrategy<
  Partial<Record<string, { disabled?: boolean }>>
> = {
  [ROLES.ADMIN]: {},
  [ROLES.ADHERENT_HOLDER]: {},
  [ROLES.ADHERENT_TEAM]: adhTeamRoleConf,
}
